import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Roles';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Roles extends RpcClass{

    /**
     *  @class Roles
     *  @alias module:src/server/com/silkplm/rpc/Roles.Roles
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param name {string} 
     * @param perms {module:src/server/com/silkplm/rpc/dto/PermissionInfo.PermissionInfo[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Role.Role>}
     */
     addRole(name, perms) {
            return RpcClass.rpcCall('/rpc/roles/add-role', [name, perms]);
    }
    /** 
     * @async
     * @param roleId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteRole(roleId) {
            return RpcClass.rpcCall('/rpc/roles/delete-role', [roleId]);
    }
    /** 
     * @async
     * @param listOfCodes {number[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     findFormConfigsByListOfPermissionCode(listOfCodes) {
            return RpcClass.rpcCall('/rpc/roles/find-form-configs-by-list-of-permission-code', [listOfCodes]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, module:src/server/com/silkplm/users/DynamicPermission.DynamicPermission[]>>}
     */
     findRequiredPermissionsForModule() {
            return RpcClass.rpcCall('/rpc/roles/find-required-permissions-for-module', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/users/DynamicPermission.DynamicPermission[]>}
     */
     listDynamicPermission() {
            return RpcClass.rpcCall('/rpc/roles/list-dynamic-permission', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/users/Permission.Permission[]>}
     */
     listPermissions() {
            return RpcClass.rpcCall('/rpc/roles/list-permissions', []);
    }
    /** 
     * @async
     * @param roleId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Role.Role>}
     */
     listRole(roleId) {
            return RpcClass.rpcCall('/rpc/roles/list-role', [roleId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Role.Role[]>}
     */
     listRoles() {
            return RpcClass.rpcCall('/rpc/roles/list-roles', []);
    }
    /** 
     * @async
     * @param userId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Role.Role[]>}
     */
     listRolesForApplicationUser(userId) {
            return RpcClass.rpcCall('/rpc/roles/list-roles-for-application-user', [userId]);
    }
    /** 
     * @async
     * @param updateRole {module:src/server/com/silkplm/model/users/Role.Role} 
     * @param perms {module:src/server/com/silkplm/rpc/dto/PermissionInfo.PermissionInfo[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Role.Role>}
     */
     updateRole(updateRole, perms) {
            return RpcClass.rpcCall('/rpc/roles/update-role', [updateRole, perms]);
    }
    /** 
     * @async
     * @param roleName {string} 
     * @param roleId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateRoleName(roleName, roleId) {
            return RpcClass.rpcCall('/rpc/roles/validate-role-name', [roleName, roleId]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Roles';
metadata.__type_short__ = 'Roles';
Roles.prototype.__metadata__ = metadata;

Roles.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Roles */
export default Roles

export { Roles }
